import {
  Button,
  List,
  ListItem,
  Popover,
  TableCell,
  TableRow,
} from '@mui/material';
import React, { useState, useEffect } from 'react';
import EditCategory from './EditCategory';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import useAuthToken from '../../hooks/getUserData';
import Label from '../elements/label/Label';
import AddExpertAdvice from './expert-advice/AddExpertAdvice';
import EditExpertAdvice from './expert-advice/EditExpertAdvice';
import DisableCategory from './DisableCategory';
import { formatText } from '../../utility/utils';

export default function ListContent({
  row,
  columns,
  index,
  tableName,
  fetchData,
  setMessage,
  setSnackbarOpen,
}) {

  const { status, id, icon, hide } = row;
  const [iconLoaded, setIconLoaded] = useState(false);
  const token = useAuthToken();
  useEffect(() => {
    if (icon) {
      const img = new Image();
      img.src = icon;
      img.onload = () => setIconLoaded(true);
    }
  }, [icon]);

  const [menuAnchor, setMenuAnchor] = useState(null);
  const handleMenuOpen = (event) => {
    setMenuAnchor(event.currentTarget);
  };

  const handleMenuClose = () => {
    setMenuAnchor(null);
  };

  return (
    <TableRow hover key={id}>
      {columns.map((column) => {
        const { id: columnId } = column;
        let cellContent;


        if (columnId === 'tag') {
          const expert = row?.tag || '-';
          cellContent = expert.charAt(0).toUpperCase() + expert.slice(1);
        } else if (columnId === 'actions') {
          cellContent = (
           <div>
              <Button
                onClick={handleMenuOpen}
                disabled={row['name'] === 'Other'}>
                <MoreVertIcon />
              </Button>
              <Popover
                anchorEl={menuAnchor}
                open={Boolean(menuAnchor)}
                onClose={handleMenuClose}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'right',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}>
                <List>
                  <ListItem>
                    <EditCategory
                      category={row}
                      fetchData={fetchData}
                      setMessage={setMessage}
                      setSnackbarOpen={setSnackbarOpen}
                      token={token}
                    />
                  </ListItem>
                  <ListItem>
                    <DisableCategory
                      category={row}
                      fetchData={fetchData}
                      token={token}
                      setMessage={setMessage}
                      setSnackbarOpen={setSnackbarOpen}
                    />
                  </ListItem>
                  <ListItem>
                    {row.expert ? (
                      <EditExpertAdvice
                        data={row}
                        fetchData={fetchData}
                        token={token}
                        setMessage={setMessage}
                        setSnackbarOpen={setSnackbarOpen}
                      />
                    ) : (
                      <AddExpertAdvice
                        data={row}
                        fetchData={fetchData}
                        token={token}
                        setMessage={setMessage}
                        setSnackbarOpen={setSnackbarOpen}
                      />
                    )}
                  </ListItem>
                </List>
              </Popover>
            </div>
          );
        } else if (columnId === 'sno') {
          cellContent = index + 1;
        } else if (columnId === 'icon') {
          cellContent = iconLoaded ? (
            <img
              src={icon}
              alt={row.name || ''}
              style={{ maxWidth: '40px', maxHeight: '40px' }}
            />
          ) : (
            <img
              src={'/default_product_category.png'}
              alt={row.name || ''}
              style={{ maxWidth: '40px', maxHeight: '40px' }}
            />
          );
        } else if (columnId === 'status') {
          cellContent =  (
            <Label color={status === 'active' ? 'success' : 'default'}>
              {status}
            </Label>
          );
        } else if (columnId === 'visibility') {
          cellContent =  (
            <Label color={hide === true ? 'error' : 'success'}>
              {hide ? 'Hidden' : 'Visible'}
            </Label>
          );
        } 
        else if (tableName === 'Categories' && columnId === 'name') {
          const categoryName = row[columnId] || '';
          cellContent = categoryName;
        } else {
          cellContent = formatText(row[columnId] || '-');
        } 

        return (
          <TableCell
            key={columnId}
            align="center"
            sx={
              columns.length - 1 === columnId
                ? {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }
                : {}
            }>
            {cellContent}
          </TableCell>
        );
      })}
    </TableRow>
  );
}
